import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import _ from "lodash"; // Import lodash here
import BarcodeReader from "react-barcode-reader";
import React, { useState, useEffect, useCallback, useRef } from "react";

import { inventoryActions } from "../../../../redux/actions";
import { PRODUCT_TYPES_ENUMS } from "../../../../system/globalEnums";
import SearchField from "../../../../shared/components/searchField/SearchField";
import CategoriesDropdown from "../../../../shared/components/selectDropdown/CategoriesDropdown";
import {
  getDefaultFilterType,
  getCustomTypesOptionList,
  getCustomCategoriesOptionList,
  getCustomSubCategoriesOptionList,
  getExternalApiProductsCombineList,
  createSearchInventoryApiOptionsList as createSelectOptionList,
} from "../../../../shared/utility";
import {
  CrossIcon,
  SearchIcon,
  BlueBoxIcon,
  LoadingIndicator,
} from "../../../../assets/icons/iconsProvider";
import {
  globalConstants,
  categoryDropdownConstants,
  EMPTY_STRING,
} from "../../../../constants";

const SearchInventory = (props) => {
  //-------props
  const {
    customTypes,
    currentStore,
    setSearchText,
    productReturn,
    asyncSelectRef,
    setProductsList,
    customCategories,
    isScanEnable = true,
    customSubCategories,
    defaultProductType = PRODUCT_TYPES_ENUMS.VIDEO_GAME,
    isSearchCustomProduct = true,
  } = props;

  const currentSearchValue = useRef("");
  const [loading, setloading] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [searchProductType, setSearchProductType] = useState(
    getDefaultFilterType(customTypes, defaultProductType)
  );
  const [productCategory, setProductCategory] = useState(EMPTY_STRING);
  const [productSubCategory, setProductSubCategory] = useState(EMPTY_STRING);

  //-------load option
  const loadOptions = async (
    inputValue,
    searchProductType,
    productCategory,
    productSubCategory,
    callback
  ) => {
    const searchValue = inputValue;

    const combinedList = await getExternalApiProductsCombineList({
      searchValue,
      currentStore,
      productCategory,
      customCategories,
      searchProductType,
      productSubCategory,
      isSearchCustomProduct: true,
    });

    if (
      currentSearchValue.current === inputValue ||
      currentSearchValue.current === ""
    ) {
      if (currentSearchValue.current !== "") {
        const selectedOptions = createSelectOptionList(combinedList, true);
        setloading(false);
        productReturn(selectedOptions, searchData);
      } else {
        // This block is executed if the search was cleared while fetching data
        // Optionally, clear the results or handle as needed
        setProductsList([]);
        setloading(false);
      }
    }
  };

  //---------handle scan
  const handleScan = async (data) => {
    if (isScanEnable) {
      if (asyncSelectRef.current) {
        asyncSelectRef.current.clearValue();
      }
      setSearchText(data);
      setSearchData(data);
      if (data) {
        debounce(data, searchProductType, productCategory, productSubCategory);
        setloading(true);
        currentSearchValue.current = data;
      }
    }
  };

  const handleError = (error) => {};

  // eslint-disable-next-line
  const debounce = useCallback(
    _.debounce(
      (value, searchProductType, productCategory, productSubCategory) => {
        loadOptions(
          value,
          searchProductType,
          productCategory,
          productSubCategory
        );
      },
      2000
    ),
    []
  );
  const clearSearchText = () => {
    debounce.cancel();
    currentSearchValue.current = "";
    setSearchData("");
    setSearchText("");
    setProductsList([]);
    setloading(false);
  };
  useEffect(() => {
    if (searchData && searchData.trim() !== "") {
      setloading(true);
      debounce(
        searchData,
        searchProductType,
        productCategory,
        productSubCategory
      );
    } // eslint-disable-next-line
  }, [searchProductType, productCategory, productSubCategory]);

  useEffect(
    () => {
      setSearchProductType(
        getDefaultFilterType(customTypes, defaultProductType)
      );
    }, // eslint-disable-next-line
    [customTypes]
  );
  return (
    <>
      <div>
        <BarcodeReader onError={handleError} onScan={handleScan} />
      </div>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <SearchField
            value={searchData}
            IconImage={SearchIcon}
            BlueBoxIcon={BlueBoxIcon}
            clearSearchText={clearSearchText}
            CrossIcon={searchData ? CrossIcon : ""}
            placeHolder="Search Item Name, UPC or SKU"
            LoadingIndicator={loading && LoadingIndicator}
            onChange={(e) => {
              const inputValue = e.target.value;
              currentSearchValue.current = inputValue; // Update ref to the current input value
              if (!inputValue) {
                setSearchData(inputValue);
                setSearchText(inputValue);
                setProductsList([]);
                setloading(false);
                return;
              }
              debounce(
                e.target.value,
                searchProductType,
                productCategory,
                productSubCategory
              );
              setSearchData(e.target.value);
              setSearchText(e.target.value);
              setloading(true);
            }}
          />
        </Col>
        <Col md={12} className="d-flex align-items-center gap-2 ">
          <CategoriesDropdown
            placeholder="Type"
            label="Type"
            isClearable={false}
            className="type-dropdown"
            noOptionsMessage="No Type Found"
            SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
            value={searchProductType}
            options={getCustomTypesOptionList(
              customTypes.filter((item) =>
                isSearchCustomProduct ? true : !item.isCustom
              )
            )}
            handleChange={(selectedOption) => {
              setSearchProductType(selectedOption);
              setProductCategory(EMPTY_STRING);
              setProductSubCategory(EMPTY_STRING);
            }}
          />
          <CategoriesDropdown
            placeholder="Category"
            label="Category"
            value={productCategory}
            className="category-dropdown"
            noOptionsMessage="No Category Found"
            SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
            options={getCustomCategoriesOptionList(
              customCategories.filter((item) =>
                isSearchCustomProduct ? true : !item.isCustom
              ),
              searchProductType?.value,
              searchProductType?.label
            )}
            handleChange={(selectedOption) => {
              setProductCategory(selectedOption || EMPTY_STRING);
            }}
          />
          <CategoriesDropdown
            options={getCustomSubCategoriesOptionList(
              customSubCategories,
              productCategory?.value,
              searchProductType?.label,
              searchProductType?.value,
              !isSearchCustomProduct,
              customCategories,
              customTypes
            )}
            label="Sub-Category"
            value={productSubCategory}
            handleChange={(selectedOption) => {
              setProductSubCategory(selectedOption || EMPTY_STRING);
            }}
            className="category-dropdown"
            noOptionsMessage="No SubCategory Found"
            placeholder="Sub-Category"
            SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
          />
        </Col>
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  customSubCategories: state.itemOrganization.customSubCategories,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getPricechartingProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getPricechartingProductById(productMetaData, productId)
    ),
  setPokemonProductInReducer: (productMetaData, value) =>
    dispatch(
      inventoryActions.setPokemonProductInReducer(productMetaData, value)
    ),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(SearchInventory);
